// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseElement } from './BaseElement';
import { Product } from './Product';
import { APP } from './APP';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 工作空间 实体类
 * 工作空间，充当名空间的用途
 */
export class WorkScope extends BaseElement {
  /** 测试产品ID : 测试产品ID，每个工作空间仅有一个测试产品 */
  private _testProductId: string;

  /** 设置：测试产品ID */
  public get testProductId() {
    return this._testProductId;
  }

  /** 获取：测试产品ID */
  public set testProductId(value: string) {
    this._testProductId = value;
  }

  /** 产品 */
  private _products: Array<Product>;

  /** 获取：产品 */
  public get products() {
    return this._products;
  }

  /** 设置：产品 */
  public set products(value: Array<Product>) {
    this._products = value;
  }

  /** 应用 */
  private _aPPs: Array<APP>;

  /** 获取：应用 */
  public get aPPs() {
    return this._aPPs;
  }

  /** 设置：应用 */
  public set aPPs(value: Array<APP>) {
    this._aPPs = value;
  }

  constructor() {
    super();
    this._testProductId = '';
    this._products = new Array<Product>();
    this._aPPs = new Array<APP>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: WorkScope, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.testProductId = element.testProductId;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.testProductId = json.TestProductId;
    if (json.Products && json.Products.length > 0) {
      json.Products.forEach((element: any) => {
        const product = Product.Create(element);
        // product.workScope = this;
        this.products.push(product);
      });
    }
    if (json.APPs && json.APPs.length > 0) {
      json.APPs.forEach((element: any) => {
        const aPP = APP.Create(element);
        // aPP.workScope = this;
        this.aPPs.push(aPP);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.TestProductId = this.testProductId;
    if (this.products && this.products.length > 0) {
      json.Products = [];
      this.products.forEach((element) => {
        json.Products.push(element.toJson());
      });
    }
    if (this.aPPs && this.aPPs.length > 0) {
      json.APPs = [];
      this.aPPs.forEach((element) => {
        json.APPs.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'testProductId', '测试产品ID', EnumDataType.String, this.testProductId, true, '测试产品ID，每个工作空间仅有一个测试产品', '', '');
    return context;
  }

  static Create(json: any): WorkScope {
    const workScope = new WorkScope();
    workScope.Deserialize(json);
    workScope.json = json;
    return workScope;
  }
}
